module.exports = __webpack_public_path__ + "static/media/a.285223f1.JPG";